<template>
  <div>
    <div class="d-flex" v-if="!hideSearch">
      <div class="w-50 ms-auto">

        <v-text-field
            @keydown.enter="onClickSearch"
            append-icon="mdi-magnify"
            @click:append="onClickSearch"
            v-model="search"
            :placeholder='$t("base.placeholderSearch")'
            dense
            outlined/>

      </div>

      <v-btn
          v-if="add"
          elevation="0"
          class="no-uppercase btn-custom-primary ml-5"
          @click="add">
        <b-img
            class="mr-2"
            :src="require('@/assets/images/ic-plus.svg')"
            width="16"
            height="16"
        />
        {{ $t("base.create") }}
      </v-btn>
    </div>

    <v-data-table
        class="home-data-table mt-10 text-body-1"
        :items-per-page="perPage"
        :page.sync="currentPage"
        :options.sync="options"
        :server-items-length="customTotalRows"
        hide-default-footer
        :loading="loading"
        :items="items"
        :headers="headers">

      <template v-slot:item.name="{ item }">
        <div>
          <div class="font-weight-bold" v-if="itemClick">
            {{ shortenText(locale === 'en' && item.nameEng ? item.nameEng : item.name, 30) }}
          </div>
        </div>
      </template>

      <template v-slot:item.time="{ item }">
        <div
          v-for="(schedule, index) in item.scheduleInfo"
          :key="schedule.scheduleId"
        >
          <div class="schedule-box align-content-center">
            <template v-if="isTimeVisible(schedule)">
              <v-chip
                @click="itemClickHandle(schedule)"
                color="blue"
                outlined
              >
                {{ renderTime(schedule) }}
              </v-chip>
            </template>
          </div>

          <v-divider
            class="mt-0 mb-0"
            v-if="index !== item.scheduleInfo.length - 1"
          />
        </div>
      </template>

      <template v-slot:item.date="{ item }">
        <div v-for="(schedule, index) in item.scheduleInfo"
             :key="schedule.scheduleId">

          <div class="schedule-box align-content-center">
            {{ renderDate(schedule) }}
          </div>

          <v-divider class="mt-0 mb-0" v-if="index !==item.scheduleInfo.length-1"></v-divider>
        </div>
      </template>

      <template v-slot:item.day="{ item }">
        <div
          v-for="(schedule, index) in item.scheduleInfo.filter(s => s.everyMonday || s.everyTuesday || s.everyWednesday || s.everyThursday || s.everyFriday || s.everySaturday || s.everySunday)"
          :key="schedule.scheduleId"
        >
          <div class="schedule-box align-content-center">
            {{ renderDay(schedule) ? $t("schedule.every") : "" }} {{ renderDay(schedule) }}
          </div>
          <v-divider
            class="mt-0 mb-0"
            v-if="index !== item.scheduleInfo.filter(s => s.everyMonday || s.everyTuesday || s.everyWednesday || s.everyThursday || s.everyFriday || s.everySaturday || s.everySunday).length - 1"
          />
        </div>
      </template>

      <template v-slot:item.updatedAt="{ item }">
        <div
          v-for="(schedule, index) in item.scheduleInfo.filter(s => s.updatedAt)"
          :key="schedule.scheduleId"
        >
          <div class="schedule-box align-content-center">
            {{ renderUpdateAt(schedule) }}
          </div>
          <v-divider
            class="mt-0 mb-0"
            v-if="index !== item.scheduleInfo.filter(s => s.updatedAt).length - 1"
          />
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <div
          v-for="(schedule, index) in item.scheduleInfo.filter(s => isTimeVisible(s) || s.startDate || s.endDate || s.everyMonday || s.everyTuesday || s.everyWednesday || s.everyThursday || s.everyFriday || s.everySaturday || s.everySunday || s.updatedAt)"
          :key="schedule.scheduleId"
        >
          <div class="text-right schedule-box align-content-center">
            <v-btn
              v-if="edit"
              small
              elevation="0"
              class="no-uppercase btn-custom-white mr-2 ms-auto"
              @click.stop="edit(schedule)"
            >
              <b-img
                class="mr-2"
                :src="require('@/assets/images/ic-edit-hospital.svg')"
                width="16"
                height="16"
              />
              {{ $t('ui.edit') }}
            </v-btn>

            <v-btn
              v-if="onDelete"
              icon
              @click.stop="handleDelete(schedule)"
            >
              <b-img
                :src="require('@/assets/images/ic-delete.svg')"
                width="22"
                height="22"
              />
            </v-btn>
          </div>
          <v-divider
            class="mt-0 mb-0"
            v-if="index !== item.scheduleInfo.filter(s => isTimeVisible(s) || s.startDate || s.endDate || s.everyMonday || s.everyTuesday || s.everyWednesday || s.everyThursday || s.everyFriday || s.everySaturday || s.everySunday || s.updatedAt).length - 1"
          />
        </div>
      </template>

      <template slot="no-data">
        <div class="w-100 align-content-center" style="min-height: 500px">
          <div class="w-100 d-flex">
            <img class="mx-auto" src="@/assets/images/ic-empty.svg" alt="empty"/>
          </div>
          <div class="text-center">{{ $t("base.noData") }}</div>
        </div>
      </template>

    </v-data-table>

    <div class="d-flex mt-6">
      <div class="ms-auto mt-3"> {{ paginationCurrentText }}</div>
      <b-pagination
          class="custom-pagination"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table">
      </b-pagination>
    </div>

  </div>

</template>

<script>
import { TYPE_FORMAT_TIME } from "../../config/constant";
import i18n from "../../lang/i18n";
import {mapState} from "vuex";
import mixin from "../../mixin";

export default {
  name: "d-table",
  mixins: [mixin],
  inheritAttrs: false,
  props: {
    fields: {
      type: [Array, Object],
      default: () => []
    },
    tableData: {
      type: [Array],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 10
    },
    edit: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    onDeleteContent: {
      type: Function,
    },
    changePassword: {
      type: Function,
    },
    add: {
      type: Function,
    },
    itemClick: {
      type: Function,
    },
    rowClick: {
      type: Boolean,
      default: false,
    },
    getItems: {
      type: Function,
    },
    customTotalRows: {
      type: Number,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {},
      search: "",
      currentPage: 1,
      dialog: false
    };
  },
  computed: {
    ...mapState(['locale']),
    items() {
      return this.tableData
    },
    headers() {
      return this.fields.map(h => {
        if (!h.value) h.value = h.key
        if (!h.text) h.text = h.label
        h.class = 'text-body-1 font-weight-bold'
        return h
      })
    },
    totalRows() {
      return this.customTotalRows ? this.customTotalRows : this.tableData.length
    },
    serversideItemLength() {
      return this.customTotalRows ? this.customTotalRows : undefined
    },
    paginationCurrentText() {
      let last = this.currentPage * this.perPage
      let first = last - this.perPage + 1
      let total = this.totalRows
      last = last > total ? total : last
      return `${first} - ${last} / ${total}`
    },

  },
  watch: {
    options: {
      handler() {
        this.onClickSearch()
      },
      deep: true,
    },
  },
  methods: {
    onClickSearch() {
      if (this.getItems) {
        // console.log("this.options", this.options)
        let optionParams = {
          searchKey: this.search,
          sortBy: this.options.sortBy[0],
          orderBy: this.options.sortDesc[0] ? "DESC" : "ASC",
          page: this.currentPage,
          itemsPerPage: this.options.itemsPerPage,
        }
        // console.log("optionParams", optionParams)
        this.getItems(optionParams)
      }
    },
    itemClickHandle(item) {
      if (this.itemClick) this.itemClick(item)
    },
    handleDelete(schedule) {
      let contents = [
        i18n.t("ui.confirmDataDelSchedule"),
        `\b ${schedule.name}`,
        i18n.t("ui.date"),
        `\b ${this.renderDate(schedule)}?`,
        '\n',
        i18n.t('ui.confirmDataDelContent2'),
      ]
      this.$root.$emit('confirmDialog', {
        title: i18n.t('ui.confirmDataDeletion'),
        contents: contents,
        variant: "delete",
        data: (schedule),
        onConfirm: this.onDelete,
        textConfirm: i18n.t('ui.delete'),
      })
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
    renderDay(schedule) {
      let list = ["everyMonday", "everyTuesday", "everyWednesday", "everyThursday", "everyFriday", "everySaturday", "everySunday"]
      let dayOfWeeks = list.filter(day => schedule[day]).map(day => i18n.t(`schedule.${day}`).replace("Every ", ""))
      return dayOfWeeks.join(", ")
    },
    renderTime(schedule) {
      // Format HH:mm and DO NOT hide '00:00'
      const start = schedule.startTime ? schedule.startTime.substring(0, 5) : ''
      const end = schedule.endTime ? schedule.endTime.substring(0, 5) : ''

      if (!start && !end) return ''
      if (start && end) return `${start} - ${end}`
      return start || end
    },
    renderDate(schedule) {
      // Nếu cả hai đều null - hiển thị thông tin vô tận
      if (!schedule.startDate && !schedule.endDate) {
        return this.$t('schedule.indefiniteSchedule') || 'Vô tận'
      }

      // Nếu chỉ có một trong hai null
      let start = schedule.startDate ? this.formatDate(schedule.startDate, TYPE_FORMAT_TIME.DD_MM_YYYY) : this.$t('schedule.noStartDate') || 'Không giới hạn'
      let end = schedule.endDate ? this.formatDate(schedule.endDate, TYPE_FORMAT_TIME.DD_MM_YYYY) : this.$t('schedule.noEndDate') || 'Không giới hạn'

      return `${start} - ${end}`
    },
    renderUpdateAt(schedule) {
      if (!schedule.updatedAt) return ''
      return this.formatDate(schedule.updatedAt, TYPE_FORMAT_TIME.DD_MM_YYYY)
    },
    isTimeVisible(schedule) {
      // Consider '00:00' as a valid time, so just check presence
      const start = schedule.startTime ? schedule.startTime.substring(0, 5) : ''
      const end = schedule.endTime ? schedule.endTime.substring(0, 5) : ''
      return !!(start || end)
    },
  },

};
</script>

<style scoped>

.custom-pagination >>> .page-item {
  margin: 5px;
}

.custom-pagination >>> .page-item .page-link {
  color: #000000;
}

.custom-pagination >>> .active > .page-link {
  background: unset;
  color: #1890FF;
  border: 1px solid #1890FF;
}

.custom-pagination >>> .disabled > .page-link {
  color: #D9D9D9;
}

.schedule-box {
  height: 70px;
}

</style>
